export default __webpack_public_path__ + "static/media/icon-trophy-silver.35be8b78.svg";